<template>
  <qx-card title="列表">
    <OrderFeeEditDialog ref="orderFeeEditDialog" @sub="getData" />
    <CollectionDialog ref="collectionDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="orderFeeDetailReportBO.ajax?cmd=expOrderFeeDetail"
            :params="fullSearchData"
            bizName="业务订单报表导出"
            bizCode="exp202202"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
          >
            <template slot="header">
                  <span>
                    {{ item.label }}
                   <el-popover v-if="item.insertParent" placement="top-end" width="50" trigger="hover" popper-class="popoverBackB">
                     <div>数据来源：订单处理-备注</div>
                    <i class="el-icon-question warning" slot="reference"></i>
                  </el-popover>
                  </span>
            </template>
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'carDriverPhone'">
                <span v-if="scope.row.carDriverPhone === 'isTotal'"></span>
                <span v-else>{{
                    scope.row[scope.column.property]
                  }}</span>
              </section>
              <section v-if="scope.column.property !== 'carDriverPhone'" :class="{ error: scope.$index === 0 }">
                <section v-if="scope.column.property === 'companyName'" @click="toDetail(scope.row)">
                  <span class="primary cur">{{ scope.row[scope.column.property] }}</span>
                </section>
                <section v-if="isPlainColumn(scope.column.property)">
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 客户单号 -->
                <section v-if="scope.column.property === 'customNumber' && scope.$index !== 0">
                  <span v-if="scope.row.customNumber === ''">/</span>
                </section>
                <!-- 客户单号 -->
                <!-- 到达日期（订单） -->
                <section v-if="scope.column.property === 'carDepartureDate' && scope.$index !== 0">
                  <span v-if="scope.row.carDepartureDate === ''">/</span>
                </section>
                <!-- 到达日期（订单） -->
                <!-- 挂车车牌 -->
                <section v-if="scope.column.property === 'trailerNumber' && scope.$index !== 0">
                  <span v-if="scope.row.trailerNumber === ''">/</span>
                </section>
                <!-- 挂车车牌 -->
                <!-- 车辆种类 -->
                <section v-if="scope.column.property === 'vehicleInfo' && scope.$index !== 0">
                  <span v-if="scope.row.vehicleInfo === ''">/</span>
                </section>
                <!-- 车辆种类 -->
                <!-- 载重量（立方） -->
                <section
                    v-if="scope.column.property === 'goodsSquare' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 载重量（吨） -->
                <section
                    v-if="scope.column.property === 'goodsWeight' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 载重量（立方） -->
                <!-- 背靠背税点 -->
                <section
                    v-if="scope.column.property === 'kappaTaxPointStr' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  <span v-if="scope.row[scope.column.property]!=='/'">
                      {{ scope.row[scope.column.property] }}
                  </span>
                  <span v-else>
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>

                <!-- 背靠背税点end -->
                <!-- 应收运费 -->
                <section
                    v-if="scope.column.property === 'costPriceDouble' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <section v-if="scope.column.property === 'costPriceDouble' && scope.$index === 0">
                  <span v-if="emptyValue(scope.row.costPriceDouble)">/</span>
                  <span v-else>{{ scope.row.costPriceDouble }}</span>
                </section>
                <!-- 应收运费 -->
                <!-- 应付运费 -->
                <section
                    v-if="scope.column.property === 'fullFreightDouble' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  <span v-if="emptyValue(scope.row.fullFreightDouble)">/</span>
                  <span v-else>{{ scope.row.fullFreightDouble }}</span>
                </section>
                <section v-if="scope.column.property === 'fullFreightDouble' && scope.$index === 0">
                  <span v-if="emptyValue(scope.row.fullFreightDouble)">/</span>
                  <span v-else>{{ scope.row.fullFreightDouble }}</span>
                </section>
                <!-- 应付运费 -->
                <!-- 税点及操作费用 -->
                <section
                    v-if="scope.column.property === 'taxPointAndOperFeeDouble' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <section v-if="scope.column.property === 'taxPointAndOperFeeDouble' && scope.$index === 0">
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 税点及操作费用 -->
                <!-- 其他费用 -->
                <section
                    v-if="scope.column.property === 'otherFeeDouble' && scope.$index !== 0"
                    class="primary cur"
                    @click="showOrderFeeEditDialog(scope.row)"
                >
                  {{ scope.row[scope.column.property] }}
                </section>
                <section v-if="scope.column.property === 'otherFeeDouble' && scope.$index === 0">
                  {{ scope.row[scope.column.property] }}
                </section>
                <!-- 税点及操作费用 -->
                <!-- 毛利润 -->
                <section v-if="scope.column.property === 'grossProfit' && scope.$index !== 0">
                  <span v-if="scope.row.grossProfit === null">/</span>
                </section>
                <!-- 毛利润 -->
                <!-- 时效/异常信息 -->
                <section v-if="scope.column.property === 'aginrProblemInfo' && scope.$index !== 0">
                  <span v-if="scope.row.aginrProblemInfo === ''">/</span>
                </section>
                <!-- 时效/异常信息 -->
                <!-- 金额 -->
                <section v-if="scope.column.property === 'aginrProblemPriceDouble' && scope.$index !== 0">
                  <span v-if="scope.row.aginrProblemPriceDouble === null">/</span>
                </section>
                <!-- 金额 -->
                <!-- 任务单号 -->
<!--                <section v-if="scope.column.property === 'taskNo' && scope.$index !== 0" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">-->
<!--                  <span v-if="scope.row.taskNo === ''">/</span>-->
<!--                  <el-popover placement="top-start" width="120" trigger="hover">-->
<!--                    <div>-->
<!--                      <p>{{ scope.row[scope.column.property]}}</p>-->
<!--                    </div>-->
<!--                    <span v_else class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>-->
<!--                  </el-popover>-->
<!--                </section>-->
                <section v-if="scope.column.property === 'taskNo' && scope.$index !== 0" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                  <span v-if="scope.row.taskNo === ''">/</span>
                  <span v-if="scope.row.taskNo && scope.row.taskNo.length < 10">{{scope.row[scope.column.property]}}</span>
                  <span v-if="scope.row.taskNo && scope.row.taskNo.length >= 10">
                    <el-popover placement="top-start" width="120" trigger="hover">
                    <div >
                      <p>{{ scope.row[scope.column.property]}}</p>
                    </div>
                    <span class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>
                  </el-popover>
                  </span>
                </section>
                <!-- 任务单号 -->
                <!-- 实际到达时间 -->
                <section v-if="scope.column.property === 'actualArrivalTime' && scope.$index !== 0">
                  <span v-if="scope.row.actualArrivalTime === ''">/</span>
                </section>
                <!-- 实际到达时间 -->
                <!-- 收款人 -->
                <section
                    v-if="scope.column.property === 'collectionMan' && scope.$index !== 0"
                    class="primary cur"
                    @click="showCollectionDialog(scope.row, true)"
                >
                  <span v-if="scope.row.collectionMan === ''">/</span>
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </section>
                <!-- 收款人 -->
                <!-- 收款时间 -->
                <section v-if="scope.column.property === 'collectionTime' && scope.$index !== 0">
                  <span v-if="scope.row.collectionTime === ''">/</span>
                </section>
                <!-- 收款时间 -->
                <!-- 收款模式 -->
                <section v-if="scope.column.property === 'collectionMode' && scope.$index !== 0">
                  <span v-if="scope.row.collectionMode === ''">/</span>
                </section>
                <!-- 收款模式 -->
                <!-- 收款备注 -->
                <section v-if="scope.column.property === 'collectionRemark' && scope.$index !== 0">
                  <span v-if="scope.row.collectionRemark === ''">/</span>
                </section>
                <!-- 收款备注 -->
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import OrderFeeEditDialog from './orderFeeEditDialog';
import CollectionDialog from './collectionDialog';
import {
  orderFeeDetailReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    OrderFeeEditDialog,
    CollectionDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'orderId', label: '订单号', fixed: true},
          {prop: 'dependTimeStr', label: '发车时间', fixed: true},
          {prop: 'sourceName', label: '线路名称', fixed: true},
          {prop: 'companyName', label: '客户名称', fixed: true},
          {prop: 'customerTypeName', label: '客户类型', fixed: true},
          {prop: 'plateNumber', label: '车牌号码', fixed: true},
          {prop: 'trailerNumber', label: '挂车车牌'},
          {prop: 'orgIdName', label: '归属部门'},
          // {prop: 'carDepartureDate', label: '到达日期'},
          // {prop: 'contractType', label: '合同类型'},
          // {prop: 'vehicleInfo', label: '车辆类型'},
          {prop: 'trailerType', label: '车辆类型'},
          // {prop: 'weightInfo', label: '装载重量'},
          // {prop: 'squareInfo', label: '装载体积'},
          {prop: 'carDriverMan', label: '主驾姓名'},
          {prop: 'carDriverPhone', label: '主驾手机'},
          {prop: 'drivingType', label: '单/双驾'},
          {prop: 'vehicleClassName', label: '车辆种类'},
          // {prop: 'squareAndWeight', label: '货物容积（实际体积重量）'},
          {prop: 'goodsSquare', label: '载重量（立方）'},
          {prop: 'goodsWeight', label: '载重量（吨）'},
          {prop: 'priceUnitNo', label: '收入单价'},
          {prop: 'kappaTaxPointStr', label: '背靠背税点'},
          {prop: 'costPriceDouble', label: '应收运费'},
          {prop: 'fullFreightDouble', label: '应付运费'},
          {prop: 'taxPointAndOperFeeDouble', label: '税点及操作费用'},
          {prop: 'otherFeeDouble', label: '其他'},
          {prop: 'grossProfit', label: '毛利润（元）'},
          {prop: 'aginrProblemInfo', label: '时效/异常信息'},
          {prop: 'aginrProblemPriceDouble', label: '金额'},
          {prop: 'getAmountDouble', label: '实收运费'},
          {prop: 'taskNo', label: '任务单号', w: 150, insertParent: 'taskNo'},
          {prop: 'actualArrivalTime', label: '实际到达时间'},
          {prop: 'paymentWayName', label: '成本模式'},
          {prop: 'customNumber', label: '客户单号'},
          {prop: 'balanceTypeName', label: '结算方式'},
          {prop: 'collectionMan', label: '收款人'},
          {prop: 'collectionTime', label: '收款时间'},
          {prop: 'collectionMode', label: '收款模式'},
          {prop: 'collectionRemark', label: '收款备注'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    isPlainColumn (property) {
      return ![
        'companyName',
        'goodsSquare',
        'goodsWeight',
        'costPriceDouble',
        'fullFreightDouble',
        'taxPointAndOperFeeDouble',
        'otherFeeDouble',
        'taskNo',
        'collectionMan',
        'kappaTaxPointStr',
      ].includes(property);
    },
    getList: orderFeeDetailReport,
    emptyValue (value) {
      return value === null || value === undefined || value === '';
    },

    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核客户' : '客户详情',
        url: `/manage/archives/customer/archives/detail?id=${item.customerId}&type=${type}`,
        full: true,
      });
    },
    showOrderFeeEditDialog (item) { // 统一设置订单费用
      this.$refs.orderFeeEditDialog.show(item);
    },
    showCollectionDialog (item) { // 收款信息
      this.$refs.collectionDialog.show(item);
    },
  },
};
</script>

<style scoped lang="scss">
.isTotal{
  color: red
}
</style>
